import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Apexcharts from "./apexcharts";
import Sparkline from "./sparkline";
import Chartjs from "./chartjs";

export default function ChartsRoutes() {
  return (
    <Routes>
      <Route index element={<Navigate to="apexcharts" replace />} />
      <Route path="apexcharts" element={<Apexcharts />} />
      <Route path="sparkline" element={<Sparkline />} />
      <Route path="chartjs" element={<Chartjs />} />
      <Route path="*" element={<Navigate to="/error" replace />} />
    </Routes>
  );
}
